import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { DistrictCreditView } from "./districtCredit-view";

export class DistrictCreditViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'اعتبار شعب';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.districtCredits = ObservableArray.create<DistrictCredit>();
        this.loaderEachDistrictCredit = new ServerSideDataLoader(filteringInformation=>this.getAllDistrictCredit(filteringInformation),150);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new DistrictCreditView();
    }
    public getTypeId(): string {
        return "VM-36DE3A45-0672-4EC7-B4EA-75B8D8DC2213"
    }
    public set districtCredits(v: ObservableArray<DistrictCredit>) { this._districtCredits = v; } public get districtCredits(): ObservableArray<DistrictCredit> { return this._districtCredits;} private _districtCredits: ObservableArray<DistrictCredit>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loaderEachDistrictCredit(v: ServerSideDataLoader) { this._loaderEachDistrictCredit = v; } public get loaderEachDistrictCredit(): ServerSideDataLoader { return this._loaderEachDistrictCredit;} private _loaderEachDistrictCredit: ServerSideDataLoader;
    
    async refresh(){
        this.loaderEachDistrictCredit.refresh();
    }
    
    async getAllDistrictCredit(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/CreditServices/GetAllDistrictCredit',{
                FurtherQueryInfo:filteringInformation
            });
            let rowNumber = 0;
            this.districtCredits.clear();
            result.EachDistrictCredit.map(row=>{
                this.districtCredits.push(...row.TakeCreditDistricts.map(q=>{
                    let r = new DistrictCredit(this);
                    r.rowNumber = ++rowNumber;
                    r.districtCreditId = q.Id;
                    r.providedDistrictId = row.ProvidedCreditDistrictId;
                    r.providedDistrictName = row.ProvidedCreditDistrictName;
                    r.takeCreditDistrictId = q.TakeCreditDistrictId;
                    r.takeCreditDistrictName = q.TakeCreditDistrictName;
                    r.amount = q.Amount;
                    r.newAmount = q.Amount;
                    return r;
                }));
                return this;
            });
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }

    async save(item:DistrictCredit){
        try {
            this.isLoading = true;
            let result;
            if (item.districtCreditId == "00000000-0000-0000-0000-000000000000") {
                result = await ServerConnection.callServer('/Complex/CreditServices/CreateDistrictCredit',{
                    Amount : item.newAmount,
                    Type : 1,
                    DaysCount : 0,
                    ProvidedCreditDistrictId : item.providedDistrictId,
                    TakeCreditDistrictId : item.takeCreditDistrictId
                });
            } else {
                result = await ServerConnection.callServer('/Complex/CreditServices/UpdateDistrictCredit',{
                    Id : item.districtCreditId,
                    Amount : item.newAmount
                });
            }
            await this.messageBoxConfirmSuccess('اعتبار با موفقیت بروزسانی شد.','عملیات موفق');
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            throw ex;
        } finally {
            this.isLoading = false;
        }
    }

}

export class DistrictCredit extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:DistrictCreditViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set districtCreditId(v: string) { this._districtCreditId = v; } public get districtCreditId(): string { return this._districtCreditId;} private _districtCreditId: string;
    public set providedDistrictId(v: string) { this._providedDistrictId = v; } public get providedDistrictId(): string { return this._providedDistrictId;} private _providedDistrictId: string;
    public set takeCreditDistrictId(v: string) { this._takeCreditDistrictId = v; } public get takeCreditDistrictId(): string { return this._takeCreditDistrictId;} private _takeCreditDistrictId: string;
    public set takeCreditDistrictName(v: string) { this._takeCreditDistrictName = v; } public get takeCreditDistrictName(): string { return this._takeCreditDistrictName;} private _takeCreditDistrictName: string;
    public set providedDistrictName(v: string) { this._providedDistrictName = v; } public get providedDistrictName(): string { return this._providedDistrictName;} private _providedDistrictName: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set newAmount(v: number) { 
        this._newAmount = getAsNumber(v,true); 
        if (this.amount != v) {
            this.isUpdated = true;
        } else {
            this.isUpdated = false;
        }
    } public get newAmount(): number { return this._newAmount;} private _newAmount: number;
    public set isUpdated(v: boolean) { this._isUpdated = v; } public get isUpdated(): boolean { return this._isUpdated;} private _isUpdated: boolean;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    private _typedParent:DistrictCreditViewModel;

    
    verify():string[]{
        let result :string[] =[];
        if (this.newAmount < 0) 
            result.push('اعتبار نامعتبر است.');
        return result;
    }
    
    async confirm(){
        try {
            this.isLoading = true;
            let verificationResult =  this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت اعتبار');
                return;
            }
            let result = await this._typedParent.save(this);
            if(result.IsSuccessful){

            }else{
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}
